import { legacyPlugins } from "/app/node_modules/.pnpm/@unhead+vue@3.4.2_@oxc-project+types@0.142.0_@vitejs+devtools-kit@0.4.10_cac@7.0.0_srvx_96e1f60f576db3a9c025ee016cf842d7/node_modules/@unhead/vue/dist/legacy.mjs";
export default {
  disableDefaults: true,
  plugins: legacyPlugins,
}